<!-- Семантическая обёртка над BaseButton variant="primary" для основных действий. -->
<template>
  <BaseButton
    variant="primary"
    v-bind="$attrs"
    :icon="icon"
    :icon-size="iconSize"
    :size="size"
    @click="$emit('click', $event)"
  >
    <slot />
  </BaseButton>
</template>

<script type="text/javascript">
import BaseButton from "@/components/UI/BaseButton.vue";

export default {
  name: "base-primary-button",
  inheritAttrs: false,
  extends: {},
  components: {
    BaseButton,
  },
  props: {
    icon: {
      type: String,
      default: "",
    },
    iconSize: {
      type: [Number, String],
      default: 16,
    },
    size: {
      type: String,
      default: "normal",
      validator: (value) => ["normal", "large"].includes(value),
    },
  },
  emits: ["click"],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  beforeCreate() {},
  mounted() {},
};
</script>
